











































import LoadingData from '@base/Components/LoadingBlock.vue';
import {defineComponent, PropType} from "@vue/composition-api";
import BlockMessage from "@base/Components/BlockMessage.vue";
import {useInertiaTable} from "@tool/Helpers/useInertiaTable";

export default defineComponent({
    components: {
        LoadingData,
        BlockMessage,
    },
    emits: [],
    props: {
        table: Object as PropType<useInertiaTable<unknown>>
    }

});
